"use strict";

exports.__esModule = true;
exports.TicketTypeListContext = void 0;
var _TicketTypeListController = require("./TicketTypeListController");
var _Utils = require("../../../Utils");
var TicketTypeListContext = exports.TicketTypeListContext = (0, _Utils.createEnhancedContext)({
  propName: "ticketTypes",
  defaultController: _TicketTypeListController.TicketTypeListController
});